import * as React from 'react';
import { motion } from 'framer-motion';
import Button from '../../Shared/Button';
import heroImage from '../../../assets/capa.jpeg';

const Hero: React.FC = () => {
  return (
    <section
      className="relative flex items-end bg-cover bg-center bg-no-repeat min-h-[70vh] lg:min-h-[calc(100vh-80px)]" // Use min-h for height
      style={{ backgroundImage: `url(${heroImage})` }}
      id="schique" // Add ID for navigation
    >
      {/* Optional Overlay */}
      {/* <div className="absolute inset-0 bg-black opacity-30 z-0"></div> */}

      <div className="container relative z-10 mx-auto px-4 pb-6 sm:pb-20 flex justify-start">
        <motion.div
          className="max-w-xl text-left text-dark" // Text aligned left, dark color
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          {/* Mobile version - 4 paragraphs */}
          <div className="sm:hidden">
            <h1 className="text-2xl text-left font-light leading-tight mt-10 pl-2">
              <p className="mb-1">Sinta-se bela</p>
              <p className="mb-1">sem deixar de</p>
              <p className="mb-1">ser você</p>
              <p>mesma</p>
            </h1>
          </div>
          
          {/* Desktop version - 3 lines */}
          <h1 className="hidden sm:block text-3xl sm:text-5xl lg:text-6xl text-left font-light leading-tight sm:mb-6 mt-10">
            Sinta-se bela
            <br />
            sem deixar de ser
            <br />
            você mesma
          </h1>
          <motion.div
            className="flex justify-start"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
          >
            <Button onClick={() => window.open('https://buk.pt/schique', '_blank')} className="mt-2 sm:mt-4 bg-bordeux text-white rounded-full hover:bg-bordeuxDark hover:scale-105 transition-all duration-300 ease-in-out">
              Agendar horário
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 